import { RightOutlined, SearchOutlined , EditOutlined , PrinterOutlined} from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, PageHeader, Row, Select, Space, Spin, Table } from 'antd'
import { Link, useNavigate } from 'react-router-dom';

import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS } from '../../utility/Constants'
import memberService from "../../api/member.service";
import JcpMonthlyReminderListView from "../../components/enrollment/jcp/JcpMonthlyReminderListView";
import TapMembershipListView from "../../components/tapcomponent/TapMembershipListView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
import gymService from "../../api/gym.service";
import GymMembershipListView from "../../components/gymcomponent/GymMembershipListView";
import clubService from "../../api/clubaffiliation.service";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";
import enrollmentService from "../../api/enrollment.service";
const { Option } = Select;



const currdate = new Date();
//const currMonth = currdate.toLocaleString('default', { month: 'short' });
const currMonth = currdate.getMonth() + 1;
const currYear = currdate.getFullYear();


//console.log("currMonth", currYear);

const defaultFormValues = {
    month_id: currMonth,
    year: currYear,
    member_id: "",
    programme_id: 0,
    paid_unpaid_status: "ALL"
};





const TournamentList = () => {
    const [form] = Form.useForm();
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [tournamentReceiptList, setTournamentReceiptList] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);
    const [tournamentDetailList, setTournamentDetailList] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);





    useEffect(()=> {
        setTournamentReceiptList([]);
        setFilteredSearchList([]);
        ProgrammeService.tournamentReceiptList().then((res) => {
//            console.log('res.data.response_data',res.data.response_data);
            setTournamentReceiptList(res.data.response_data);
            setFilteredSearchList(res.data.response_data)
        });  
    },[]);

    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = tournamentReceiptList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
    }



    const columns = [
        
        {
          title: 'Name',
          dataIndex: 'customer_name',
          key: 'customer_name',
          sorter: (a, b) => a.receipt_no.localeCompare(b.customer_name),
        },
        {
            title: 'Invoice No',
            dataIndex: 'receipt_no',
            key: 'receipt_no',
            sorter: (a, b) => a.receipt_no.localeCompare(b.receipt_no),
          },
        {
          title: 'Invoice Date',
          dataIndex: 'receipt_date',
          key: 'receipt_date',
          sorter: (a, b) => a.receipt_date.localeCompare(b.receipt_date),
        },
        {
            title: 'Total Paid',
            dataIndex: 'net_payble_amount',
            key: 'net_payble_amount',
            align:'right',
            render: (selectedObj,row) => (
                <Space size="middle">
                  {row.net_payble_amount.toFixed(2)}
                </Space>
            )
        },
        {
            title: 'Action',
            key: 'action',
            width:90,
            render: (selectedObj) => (
                <Space style={{display:'flex',flexDirection:'row'}}>
                    <Link to={`/tournament/entry/${selectedObj.receipt_id}/${selectedObj.payment_id}`} >
                        <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" >Edit <EditOutlined /></Button>
                    </Link>
                    
                    <a href={`${PRINT_BASE_URL}taxinvoice/generalreceiptprint/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
                    </a>
                </Space>
            )
        },
        
      ];

      const fetchTournamentDetailData = (receiptId) => {
        const data_params = {
            formdata: {
                receipt_id: receiptId,
            },
        };
        enrollmentService.TournamentReceiptData(data_params).then((res4) => {
            if (res4.data.response_status === SUCCESS_STATUS) {
                const receipt_datam = res4.data.response_data;
                setTournamentDetailList((prevData) => ({
                    ...prevData,
                    [receiptId]: receipt_datam, // Store the detail data with receiptId as key
                }));
            }
        });
    };


    const toggleRowExpand = (record) => {
        const recordKey = record.key; // Assuming you have a unique key for each record
        setExpandedRowKeys((prevExpandedRowKeys) =>
            prevExpandedRowKeys.includes(recordKey)
                ? prevExpandedRowKeys.filter((key) => key !== recordKey)
                : [...prevExpandedRowKeys, recordKey]
        );
    };
    
      const expandedRowRender = (record) => {

        // console.log("DATA" , data.detailsData)
        // return false;
        //setTournamentDetailList([]);
        const detailColumns = [
          {
            title: 'Tournament',
            dataIndex: 'is_tournament',
            key: 'is_tournament',
            render: (selectedObj,row) => (
                <Space size="middle">
                  {row.is_tournament == "Y" ? "Yes" : "No"}
                </Space>
            )
          },
          {
            title: 'Ledger',
            dataIndex: 'account_name',
            key: 'account_name',
          },
          {
            title: 'Amount',
            //dataIndex: 'amount',
            dataIndex: 'amount',
            //dataIndex: ['time_tag'],
            key: 'amount',
          },
          {
            title: 'Tournament',
            //dataIndex: 'tran_tag',
            dataIndex: 'tournament_name',
            //dataIndex: ['coach_amount'],
            key: 'tournament_name',
           
          },
         
        
        ];


        if (!tournamentDetailList[record.receipt_id]) {
            fetchTournamentDetailData(record.receipt_id);
        }

        return (
            <Table
                columns={detailColumns}
                dataSource={tournamentDetailList[record.receipt_id] || []}
                pagination={false}
            />
        );
      };
    

    return (

        <div>

            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="General Receipt List"
                        subTitle=""

                    ></PageHeader>

                    <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} />

                    <div className="tableView nestedTable">
                    
                            <Table 
                                //rowKey={commonUtility.randomID()} 
                                rowKey={(record) => record.receipt_id} 
                                columns={columns}  
                                dataSource={filteredSearchList}  
                                size="small"
                                // expandable={{
                                //     expandedRowRender: (record) => expandedRowRender(record),
                                //     defaultExpandedRowKeys: ['0'],
                                //   }}                   

                                  expandable={{
                                    expandedRowRender: (record) => expandedRowRender(record),
                                    //expandedRowKeys: expandedRowKeys,
                                    //onExpand: (expanded, record) => toggleRowExpand(record),
                                    defaultExpandAllRows: false,
                                }}
                             />
                
                    </div>
                  

                </div>
            </div>

        </div>


    )
}

export default TournamentList